module.exports = __webpack_public_path__ + "static/icons/icon-plane-bd12ed6130b7f34bdf5940dce17d5c46.svg";